<template>
  <!-- dialog add docs -->
  <dialogTemplate
    :openDialog="isOpen"
    :widthDialog="'800px'"
    :classDialog="'add-docs-dialog'"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('closed')"
    :appendToBody="true"
    :modalAppendToBody="true"
  >
    <template #header>
      <div class="margin-left-10">
        <h5 class="dialogTitle">Danh sách đơn vị chuyển xử lý</h5>
      </div>
    </template>
    <template #body>
      <div class="margin-bottom-10" style="max-height: 300px">
        <el-table
          ref="multipleTable"
          :data="processes"
          size="medium"
          style="width: 100%"
        >
          <el-table-column
            label="STT"
            width="50"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span class="">{{
                scope.$index + 1
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="Đơn vị nhận văn bản"
            width="400"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span class="">{{
                scope.row.deptReceiverName
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="Thời gian nhận"
            width="150"
          >
            <template slot-scope="scope">
              <span class="">{{
                convertTimeToString(scope.row.sendTime)
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="Tình trạng xử lý:"
            width="120"
          >
            <template slot-scope="scope">
              <span class="clickable">{{
                processStatusLabel(scope.row)
              }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </template>
    <template #footer>
    </template>
  </dialogTemplate>
</template>

<script>
  import dateFormatter from "../../../filters/dateFormatter";
  import constants from "../../../constants";

  export default {
    name: "process-moreinfo-chuyentiep",
    props: ["isOpen", "processes"],
    filters: {dateFormatter},
    components: {
      dialogTemplate: () => import("../../common/custom-dialog.vue"),
      VuePerfectScrollbar: () => import("vue-perfect-scrollbar")
    },
    data() {
      return {
        perfectScrollbarSetting: {
          maxScrollbarLength: 550
        }
      }
    },
    methods: {
      convertTimeToString(value) {
        return dateFormatter(value);
      },
      processStatusLabel(process) {
        switch (process.status) {
          case constants.INCOMING_PROCESS_STATUS.CHO_XU_LY:
            return "Chờ xử lý";
          case constants.INCOMING_PROCESS_STATUS.DA_XU_LY:
            return "Đã xử lý";
          case constants.INCOMING_PROCESS_STATUS.TU_CHOI:
            return "Từ chối";
          default:
            return "-";
        }
      }
    }
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/doc-in/components/process-moreinfo-chuyentiep.vue